import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, BrowserRouter } from "react-router-dom";
import './index.css';
import About from './pages/about.js';
import Home from './pages/home.js';
import Contact from './pages/contact.js';
import Services from './pages/services.js';
import Application from './pages/application.js';

function App() {
  return (
    <div style={{background: "black",}}>
      <div>
        <BrowserRouter>
          <Routes>
            <Route index element={<Home />}/>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            <Route path="/applications" element={<Application />} />
          </Routes>
        </BrowserRouter>
      </div>
      
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

